<template>
  <datepicker v-model="picked" />
</template>
